(function (app) {

    app.provider("firelightApi",
        [
            function () {
                this.$get = [
                    "crmApiGateway", function (crmApiGateway) {
                        var service = {};
                        service.initiateFirelightSso = function(caseId, model) {
                            return crmApiGateway.post("/FirelightSso/" + caseId, model);
                        }

                        service.continueFirelightSso = function(caseId, accountId) {
                            return crmApiGateway.post("/FirelightSso/" + caseId + "/Account/" + accountId);
                        }

                        service.getFirelightApplication = function(accountId) {
                            return crmApiGateway.get("/FirelightApplication/" + accountId);
                        }
                        return service;
                    }
                ];
            }
        ]);

})(window.app); //jshint ignore:line